import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isInternalApi =
      req.url.includes('app.happyreport.store/api') ||  req.url.includes('10.10.30.80:8081/api') || req.url.includes('10.201.16.51:8080/api') || 
      req.url.includes('localhost:8080/api');

    const isLoginRequest = req.url.endsWith('/api/authenticate');

    if (!isInternalApi || isLoginRequest) {
      return next.handle(req);
    }

    return from(this.authService.getToken()).pipe(
      mergeMap((token) => {
        if (token) {
          req = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
        }
        return next.handle(req);
      })
    );
  }
}
